import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { env } from './env.js';

// Single shared Better Auth client. `baseURL` points at the api origin so
// every request (sign-in, get-session, sign-out) lands at the same Hono
// instance that owns the session table. Credentials are sent automatically
// per Better Auth's defaults (cookie-based session).
// Plugins:
//   - magicLinkClient → adds authClient.signIn.magicLink({ email, callbackURL })
export const authClient = createAuthClient({
  baseURL: env.API_URL,
  plugins: [magicLinkClient()],
});

// All of these are proxy callables — Better Auth's createDynamicPathProxy
// turns property access into a route, e.g. authClient.signOut → proxy with
// path=['signOut'] → calling it POSTs to /api/auth/sign-out. The proxy's
// apply trap reads only its captured `path` closure, not `this`, so plain
// destructuring is safe.
//
// DO NOT .bind(authClient) these. .bind itself walks the proxy
// (signOut.bind → proxy with path=['signOut','bind']; calling that with
// authClient as arg triggers an apply that destructures arg, accessing
// arg.fetchOptions.method.toUpperCase(), which in turn fires more apply
// traps → a bogus GET /api/auth/fetch-options/method/to-upper-case and
// a "[object Promise] is not a valid HTTP method" TypeError.
export const { useSession, signIn, signUp, signOut, requestPasswordReset, resetPassword } =
  authClient;
